import { Vue, Component } from 'vue-property-decorator'

@Component
export default class OrderPaymentResultHeader extends Vue {
  render () {
    return (
      <h1 class="order-payment-result-header">
        Оплата заказа
      </h1>
    )
  }
}
